import axiosInstance from '@/plugins/axios';

// Tela Agentes nocivos e aposentadoria especial (S-2240) — porte do BFF `agentes-nocivos`.
const BASE = 'agentes-nocivos';

const ServiceAgentesNocivos = {
  // Filtros: competências disponíveis.
  availableCompetencies: () => axiosInstance.post(`${BASE}/available-competencies`, {}),
  // Dashboard: contagem por categoria de agente nocivo.
  countCategories: (body) => axiosInstance.post(`${BASE}/count-categories`, body ?? {}),
  // Dashboard: gráficos (donuts).
  chartsCounts: (body) => axiosInstance.post(`${BASE}/charts-counts`, body ?? {}),
  // Tabela: riscos de aposentadoria especial (paginada + ordenação server-side).
  retirementRisks: (body, page = 0, size = 25, sort) =>
    axiosInstance.post(`${BASE}/retirement-risks`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  // Tabela: agentes nocivos (paginada + ordenação server-side).
  nociveAgents: (body, page = 0, size = 25, sort) =>
    axiosInstance.post(`${BASE}/nocive-agents`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  // Contagem de trabalhadores por agente nocivo.
  countCollaboratorsByAgent: (body) =>
    axiosInstance.post(`${BASE}/count-collaborators-by-agent`, body ?? {}),
  // Exportações: enfileiram um export persistido (report_process) — não retornam mais binário.
  exportRetirementRisks: (body) =>
    axiosInstance.post(`${BASE}/retirement-risks/export`, body ?? {}),
  exportNociveAgents: (body) => axiosInstance.post(`${BASE}/nocive-agents/export`, body ?? {}),
};

export default ServiceAgentesNocivos;
